import { render, staticRenderFns } from "./AdmissionsCinemas.vue?vue&type=template&id=9fc13b1c"
import script from "./AdmissionsCinemas.vue?vue&type=script&lang=js"
export * from "./AdmissionsCinemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc13b1c')) {
      api.createRecord('9fc13b1c', component.options)
    } else {
      api.reload('9fc13b1c', component.options)
    }
    module.hot.accept("./AdmissionsCinemas.vue?vue&type=template&id=9fc13b1c", function () {
      api.rerender('9fc13b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsCinemas.vue"
export default component.exports